// extracted by mini-css-extract-plugin
export default {"BuildingInfo":"BuildingInfo_BuildingInfo__Xj24r","half":"BuildingInfo_half__Cp-KB"};